let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bJrAA")).then(() => parcelRequire('m7bQa'));